import React from "react";

interface PaginationProps {
  page: number;
  size: number;
  total: number;
  onChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ page, size, total, onChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / size));

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center gap-2 text-sm">
      <button
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="px-3 py-1 rounded border border-border-gray bg-white disabled:opacity-40 hover:bg-default-99 disabled:cursor-not-allowed"
      >
        ‹ Prev
      </button>
      <span className="text-gray-500">
        Page {page} of {totalPages}
      </span>
      <button
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="px-3 py-1 rounded border border-border-gray bg-white disabled:opacity-40 hover:bg-default-99 disabled:cursor-not-allowed"
      >
        Next ›
      </button>
    </div>
  );
};
